import React from "react";
import Slide1 from "../../../../../img/topbanner1.png";
import Slide2 from "../../../../../img/topbanner2.png";
import Carousel from "react-bootstrap/Carousel";

const CarouselSec = () => {
  return (
    <Carousel
      className="homeCarousel"
      nextIcon={null}
      prevIcon={null}
      indicators={false}
    >
      <Carousel.Item interval={2000}>
        <img className="d-block w-100" src={Slide1} alt="First slide" />
      </Carousel.Item>
      <Carousel.Item interval={2000}>
        <img className="d-block w-100" src={Slide2} alt="Second slide" />
      </Carousel.Item>
    </Carousel>
  );
};
export default React.memo(CarouselSec);
